// src/mobile/js/mobileCharacterLimits.js

const mobileCharacterLimits = {
    name: 50,
    title: 80, // Reduced from 100 to encourage brevity
    location: 80, // Reduced for conciseness
    email: 50,
    phone: 20,
    summary: 1000, // Reduced from 1500
    experience: 800, // Reduced from 1000
    skills: 250, // Reduced from 300
    education: 400, // Reduced from 500
    publications: 400, // Reduced from 500
};

export default mobileCharacterLimits;
